import { render, staticRenderFns } from "./FXSpotForwardSwap.vue?vue&type=template&id=49f6e2ac&scoped=true&"
import script from "./FXSpotForwardSwap.vue?vue&type=script&lang=js&"
export * from "./FXSpotForwardSwap.vue?vue&type=script&lang=js&"
import style0 from "./FXSpotForwardSwap.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FXSpotForwardSwap.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./FXSpotForwardSwap.vue?vue&type=style&index=2&id=49f6e2ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f6e2ac",
  null
  
)

export default component.exports